import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { SectionHeading as HeadingTitle } from "./misc/Headings.jsx"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Container as ContainerBase } from "./misc/Layouts.jsx"

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`
const ThreeColumn = tw.div`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap`
const Column = tw.div`mt-24 lg:w-1/3`
const HeadingInfoContainer = tw.div`flex flex-col items-center`
const Card = tw.div`lg:mx-4 xl:mx-8 max-w-sm flex flex-col h-full rounded border-2`
const Details = tw.div`p-6   flex-1 flex  flex-col items-center lg:block lg:text-left`
const Meta = tw.div` text-secondary-100 font-medium text-sm flex items-center leading-none`
const Title = tw.div`mt-4 leading-snug font-bold text-lg  h-12`
const Description = tw.p`my-4 text-sm h-24`
const Button = tw(
  Link
)`px-8 py-4 font-bold rounded bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300 rounded-full tracking-wider  text-sm hover:shadow-xl transform hocus:translate-x-px hocus:-translate-y-px focus:shadow-outline`

const UseCase = props => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(sort: { fields: [fields___slug], order: ASC }) {
          nodes {
            excerpt
            fields {
              slug
            }
            frontmatter {
              service
              category
              title
              description
              thumbnail {
                childrenImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                    height: 230
                  )
                }
              }
            }
          }
        }
      }
    `
  )

  const posts = allMarkdownRemark.nodes.filter(
    filter => filter.frontmatter.service == props["service"]
  )

  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          <HeadingTitle id="usecase">
            <>事例紹介</>
          </HeadingTitle>
        </HeadingInfoContainer>
        <ThreeColumn>
          {posts.map(post => (
            <Column>
              <Card>
                <GatsbyImage
                  image={getImage(
                    post.frontmatter.thumbnail.childrenImageSharp[0]
                  )}
                />
                <Details>
                  <Meta>{post.frontmatter.category}</Meta>
                  <Title>{post.frontmatter.title}</Title>
                  <Description>{post.frontmatter.description}</Description>
                  <Button to={post.fields.slug}>詳細はこちら</Button>
                </Details>
              </Card>
            </Column>
          ))}
        </ThreeColumn>
      </Content>
    </Container>
  )
}

export default UseCase
